import { compressImageFile } from "../../helpers/imageCompress";
import { useState } from "react";

const useReservationForm = () => {
  const [formData, setFormData] = useState({
    guest_id: "",
    guest_name: "",
    mobile_number: "",
    room_id: "",
    room_number: "",
    check_in_date: "",
    check_out_date: "",
    number_of_nights: "",
    room_type: "",
    no_of_beds: "",
    payment_mode: "",
    ac_non_ac: "",
    discount: "",
    food_charges: "",
    package: "",
    extrabedcharges: 0,
    remark: "",
    tariff_charges: "",
    guest_type: "",
    id_proof_type: "",
    status: "PENDING",
    booking_source: "",
    Amount_Advance: 0,
    guest_partners: [],
  });

  const [dateError, setDateError] = useState("");
  const [partnerFileSizeErrors, setPartnerFileSizeErrors] = useState({});

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newData = { ...prev, [name]: value };

      if (newData.check_in_date && newData.check_out_date) {
        const checkIn = new Date(newData.check_in_date);
        const checkOut = new Date(newData.check_out_date);
        const diffTime = Math.abs(checkOut - checkIn);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (checkOut < checkIn) {
          setDateError("Check-out date cannot be before check-in date");
        } else {
          setDateError("");
          newData.number_of_nights = diffDays;
        }
      }

      return newData;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const addGuestPartner = () => {
    setFormData((prev) => ({
      ...prev,
      guest_partners: [
        ...prev.guest_partners,
        {
          name: "",
          mobile_number: "",
          gender: "",
          id_proof_type: "",
          relationship: "",
          files: {
            id_proof_front: null,
            id_proof_back: null,
            partner_photo: null,
          },
        },
      ],
    }));
  };

  const removeGuestPartner = (index) => {
    setFormData((prev) => ({
      ...prev,
      guest_partners: prev.guest_partners.filter((_, i) => i !== index),
    }));
  };

  const handlePartnerInputChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      guest_partners: prev.guest_partners.map((partner, i) =>
        i === index ? { ...partner, [field]: value } : partner
      ),
    }));
  };

  const handlePartnerFileChange = async (index, field, rawFile) => {
    const file = await compressImageFile(rawFile);
    // Validate file size (5MB = 5 * 1024 * 1024 bytes)
    const maxSize = 2 * 1024 * 1024;
    let error = null;
    
    if (file && file.size > maxSize) {
      error = `File size must be less than 5MB. Current size: ${(file.size / (1024 * 1024)).toFixed(2)}MB`;
    }

    // Update file size errors
    setPartnerFileSizeErrors((prev) => ({
      ...prev,
      [`${index}_${field}`]: error,
    }));

    setFormData((prev) => ({
      ...prev,
      guest_partners: prev.guest_partners.map((partner, i) =>
        i === index
          ? {
              ...partner,
              files: {
                ...partner.files,
                [field]: file,
              },
            }
          : partner
      ),
    }));
  };

  const clearPartnerFileSizeErrors = () => {
    setPartnerFileSizeErrors({});
  };

  const resetForm = () => {
    setFormData({
      guest_id: "",
      guest_name: "",
      mobile_number: "",
      room_id: "",
      room_number: "",
      check_in_date: "",
      check_out_date: "",
      number_of_nights: "",
      room_type: "",
      no_of_beds: "",
      payment_mode: "",
      ac_non_ac: "",
      discount: "",
      food_charges: "",
      package: "",
      extrabedcharges: 0,
      remark: "",
      tariff_charges: "",
      guest_type: "",
      id_proof_type: "",
      status: "PENDING",
      booking_source: "",
      Amount_Advance: 0,
      guest_partners: [],
    });
    setDateError("");
    setPartnerFileSizeErrors({});
  };

  return {
    formData,
    dateError,
    partnerFileSizeErrors,
    handleDateChange,
    handleInputChange,
    resetForm,
    setFormData,
    addGuestPartner,
    removeGuestPartner,
    handlePartnerInputChange,
    handlePartnerFileChange,
    clearPartnerFileSizeErrors,
  };
};

export default useReservationForm;
